export const jsEnvironment = 'web';
